<template>
    <div>
        <div class="content-header">
            <PageTitleComponent :title="title" :atras="atras" />
        </div>
  
        <!-- Slot opcional para datos extra -->
        <slot name="extra-data"></slot>
  
        <section class="content">
            <div class="container-fluid">
                <div class="card card-primary card-outline card-outline-tabs">
                    <div class="card-header p-0 border-bottom-0">
                        <ul class="nav nav-tabs" id="custom-tabs-five-tab" role="tablist">
                            <li 
                                v-for="(tab, index) in tabs" 
                                :key="index" 
                                class="nav-item"
                            >
                                <a 
                                    :class="show === tab.tab ? 'nav-link active ml-1' : 'nav-link'"
                                    href="#"
                                    @click.prevent="show = tab.tab"
                                >
                                    {{ tab.nombre }}
                                </a>
                            </li>
                        </ul>
                    </div>
  
                    <div class="card-body">
                        <div class="tab-content">
                            <div class="tab-pane fade active show">
    
                                <transition name="fade" mode="out-in">
                                    <div :key="show">
                                        <slot :name="show"></slot>
                                    </div>
                                </transition>
                            </div>                        
                        </div>
                    </div>
                </div>
            </div>            
        </section>
    </div>
</template>
  
<script>
    import PageTitleComponent from '@/components/backend/components/PageTitleComponent';
  
    export default {
        props: {
            tabs: Array,
            initialTab: String,
            title: String,
            atras: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                show: this.initialTab
            }
        },
        watch: {
            show(newValue) {
                this.$emit('selectTab', newValue);
            }
        },
        components: {
            PageTitleComponent
        }
    }
</script>

<style scoped>
.nav-tabs {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  margin: 0;
  padding-top: 4px;
}

.nav-item {
  flex:auto;
  text-align: center;
}

.nav-link {
  display: flex;
  margin: 2px;
  align-items: center;
  justify-content: center;
  background-color: #dee2e6;
  font-size: 1 rem;
  transition: background-color 0.2s ease;
  border: none;
}

@media (max-width: 1024px) {
  .nav-tabs {
    flex-direction: column;
    padding: 1.25rem;
  }

  .nav-item {
    width: 100%;
  }

  .nav-link {
    background-color: #dee2e6;
    margin: 3px 0;
    border-radius: 5px;
  }

  .nav-tabs .nav-link:focus {
    border-color: lightgray lightgray white lightgray;
    border-width: 1px;
  }

  .nav-tabs .nav-link:hover {
    border-color: lightgray lightgray;
    border-width: 5px 1px 1px 1px;
  }
}
</style>